module.exports = __webpack_public_path__ + "img/dj_top.dbc654dd.png";